import React from "react";

import svg from "../../assets/images/icons/collapse_all.svg";

export const CollapseAllIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={svg}
        alt={alt || "Collapse"}
    />
);
